(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/start-page/assets/javascripts/start-page_desktop.js') >= 0) return;  svs.modules.push('/modules/start-page/assets/javascripts/start-page_desktop.js'); 'use strict';

svs.modules = svs.modules || {};
var SELECTOR_MAIN_CONTENT = '#main-content';
var SELECTOR_COOKIE_INFO = '.js-cookie-info';

function setUpListeners() {
  var mainContentEl = document.querySelector(SELECTOR_MAIN_CONTENT);

  if (!mainContentEl) {
    return;
  }

  var cookieInfoEl = mainContentEl.querySelector(SELECTOR_COOKIE_INFO);

  if (cookieInfoEl) {
    cookieInfoEl.addEventListener(showAboutCookies);
  }
}

function showAboutCookies(e) {
  e.preventDefault();
  var cookieView = svs.start_page.templates.cookie_info();
  svs.core.module.load('/cl/components/modal', null, function () {
    svs.components.Modal.show(cookieView, {}, {
      leftButton: 'Stäng',
      rightButton: {
        visible: false
      },
      title: 'OM COOKIES'
    });
  });
}

setUpListeners();
 })(window);